var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { TableSortIcons } from '@web/components/layout/Table/TableSortIcons';
import { widgetMetricTableColgroupInvocationsByApp, widgetMetricTablePairHeaderThClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTableInvocationsTimeSpentRow } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToAppsUsageForDateRange } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { SortOrderEnum } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var SECTION_I18N = 'app.performanceReview.employeePerformanceReview.aiAdoptionAndUsageSection';
var SORT_FIELDS = [
    {
        field: 'invocations',
        headerKey: "".concat(SECTION_I18N, ".tablesData.headers.invocations")
    },
    {
        field: 'timeSpent',
        headerKey: "".concat(SECTION_I18N, ".tablesData.headers.timeSpent")
    }
];
export var InvocationsByApp = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = useState({
        field: 'invocations',
        direction: SortOrderEnum.DESC
    }), sortBy = _c[0], setSortBy = _c[1];
    var _d = trpc.invocationsByApp.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var items = data.items;
    var sortMult = sortBy.direction === SortOrderEnum.ASC ? 1 : -1;
    var sortedItems = __spreadArray([], items, true).sort(function (a, b) {
        var aValue = sortBy.field === 'invocations'
            ? a.invocations.count
            : a.timeSpent.minutes;
        var bValue = sortBy.field === 'invocations'
            ? b.invocations.count
            : b.timeSpent.minutes;
        return sortMult * (aValue - bValue);
    });
    var headers = {
        label: t("".concat(SECTION_I18N, ".tablesData.headers.label")),
        invocations: t("".concat(SECTION_I18N, ".tablesData.headers.invocations")),
        timeSpent: t("".concat(SECTION_I18N, ".tablesData.headers.timeSpent"))
    };
    var appLabel = function (appName) {
        return t("".concat(SECTION_I18N, ".tablesData.apps.").concat(appName));
    };
    var totalLabel = t("".concat(SECTION_I18N, ".tablesData.total"));
    var navigateToGeminiAppsUsage = function () {
        navigateToAppsUsageForDateRange({
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId,
            tab: 'gemini'
        });
    };
    var tableData = __spreadArray(__spreadArray([], sortedItems.map(function (item) {
        return metricTableInvocationsTimeSpentRow(item.appName, appLabel(item.appName), item, {
            showTeamDiff: Boolean(userId),
            isSecondaryDiffHidden: isSecondaryDiffHidden,
            onNavigate: navigateToGeminiAppsUsage
        });
    }), true), (data.total
        ? [
            metricTableInvocationsTimeSpentRow('total', totalLabel, data.total, {
                showTeamDiff: Boolean(userId),
                isSecondaryDiffHidden: isSecondaryDiffHidden,
                isTotalRow: true,
                onNavigate: navigateToGeminiAppsUsage
            })
        ]
        : []), true);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t("".concat(SECTION_I18N, ".invocationsByApp")), description: t(userId
                    ? 'widgetTitleDescriptions.aiAdoptionAndUsage.invocationsByAppUser'
                    : 'widgetTitleDescriptions.aiAdoptionAndUsage.invocationsByAppTeam'), insightType: InsightTypeEnum.invocationsByApp, insightsData: sortedItems, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t("".concat(SECTION_I18N, ".invocationsByApp")), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            return [2 /*return*/, __spreadArray(__spreadArray([], sortedItems.map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[headers.label] = appLabel(item.appName),
                                        _a[headers.invocations] = item.invocations.count,
                                        _a[headers.timeSpent] = item.timeSpent.formatted,
                                        _a);
                                }), true), (data.total
                                    ? [
                                        (_a = {},
                                            _a[headers.label] = totalLabel,
                                            _a[headers.invocations] = data.total.invocations.count,
                                            _a[headers.timeSpent] = data.total.timeSpent.formatted,
                                            _a)
                                    ]
                                    : []), true)];
                        });
                    }); }, disabled: isAiButtonDisabled(sortedItems) }) }), _jsx(Table, { columns: __spreadArray([
                    {
                        title: headers.label,
                        isVisible: true,
                        className: 'min-w-0 !text-left'
                    }
                ], SORT_FIELDS.map(function (_a) {
                    var field = _a.field, headerKey = _a.headerKey;
                    return ({
                        title: (_jsxs("span", __assign({ className: "inline-flex items-center gap-1" }, { children: [t(headerKey), _jsx(TableSortIcons, { isActive: sortBy.field === field, direction: sortBy.direction })] }))),
                        isVisible: true,
                        colspan: userId ? 3 : 2,
                        className: "".concat(widgetMetricTablePairHeaderThClass, " cursor-pointer"),
                        orderByField: field
                    });
                }), true), data: isInsightsDataEmpty(sortedItems) ? [] : tableData, columnColStyles: widgetMetricTableColgroupInvocationsByApp(Boolean(userId)), tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top", sortingOption: {
                    show: true,
                    elementIndex: SORT_FIELDS.findIndex(function (_a) {
                        var field = _a.field;
                        return field === sortBy.field;
                    }) + 1,
                    orderByField: sortBy.field,
                    direction: sortBy.direction,
                    orderByDirection: sortBy.direction
                }, setSortingOption: function (_a) {
                    var orderByField = _a.orderByField, direction = _a.direction;
                    return setSortBy({
                        field: orderByField,
                        direction: direction
                    });
                } })] })));
};
